import type { HTMLAttributes } from "react";
import { cx } from "../cx";
/**
 * Avatar del sistema (iniciales). `skeleton` = el mismo hueco mientras no se
 * sabe de quién es: la TALLA la pone la pieza (`sk-avatar`), no el markup —
 * si el avatar cambia de talla, su esqueleto no se queda mintiendo.
 * `size="s"`: el avatar pequeño de una celda o de una línea (`sk-avatar--s`),
 * el dueño de un cuaderno en la biblioteca (biblioteca.html, ficha.html).
 */
export function Avatar({ skeleton, size, className, children, style, ...rest }: { skeleton?: boolean | undefined; size?: "s" | undefined } & HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cx("sk-avatar", size === "s" && "sk-avatar--s", skeleton === true && "sk-skeleton", className)}
      aria-hidden={skeleton === true ? true : undefined}
      style={style}
      {...rest}
    >{skeleton === true ? null : children}</span>
  );
}
